(function () {
  'use strict';
  if (window.PlaybackShopUI) return;
  const keys = { query:'pb_q', category_id:'pb_category', hub_id:'pb_hub', equipment_id:'pb_equipment', brand:'pb_brand', condition:'pb_condition', size:'pb_size', sort:'pb_sort', page:'pb_page' };
  const make = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  const value = (item, key) => {
    if (key === 'brand') return item.brand && item.brand.status === 'as_listed' ? item.brand.label : '';
    if (key === 'condition') return item.condition && item.condition.status === 'as_listed' ? item.condition.filter_value : '';
    if (key === 'size') return item.size && item.size.status === 'listed' ? item.size.filter_value : '';
    return item[key] || '';
  };
  async function init(root) {
    if (root.dataset.pbReady) return;
    root.dataset.pbReady = 'true';
    const home = root.dataset.pbHome === 'true';
    const related = root.dataset.pbMode === 'related';
    const strings = JSON.parse(root.querySelector('[data-pb-strings]').textContent);
    const grid = root.querySelector('[data-pb-grid]');
    const error = () => {
      const notice = make('p', 'pb-noscript', strings.load_error);
      notice.setAttribute('role', 'status');
      if (!related) grid.before(notice);
    };
    try {
      const engine = window.PlaybackCatalogEngine;
      if (!engine) throw new Error('Catalog engine missing');
      let feed = JSON.parse(root.querySelector('[data-pb-live]').textContent);
      const manifestResponse = await fetch(root.dataset.pbManifest, {credentials:'same-origin'});
      if (!manifestResponse.ok) throw new Error('Catalog mapping unavailable');
      const manifest = await manifestResponse.json();
      async function loadPage(pageNumber) {
        const url = new URL(root.dataset.pbCollection, location.origin);
        url.searchParams.set('view', 'playback-feed');
        url.searchParams.set('page', String(pageNumber));
        url.searchParams.set('sort_by', 'created-descending');
        const previewTheme = new URL(location.href).searchParams.get('preview_theme_id');
        if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
        const response = await fetch(url, {credentials:'same-origin'});
        if (!response.ok) throw new Error('Catalog page unavailable');
        return response.json();
      }
      if (Number(feed.current_page) > 1) feed = await loadPage(1);
      let next = feed.next_page;
      const seenPages = new Set([1]);
      while (next) {
        if (seenPages.has(next)) throw new Error('Repeated catalog page');
        seenPages.add(next);
        const page = await loadPage(next);
        feed.products.push(...page.products);
        next = page.next_page;
      }
      const liveProducts = [...new Map(feed.products.map(item => [String(item.id), item])).values()];
      const products = engine.intersectLive(manifest, liveProducts);
      const catalog = engine.create(manifest);
      const form = root.querySelector('[data-pb-filters]');
      const search = root.querySelector('[data-pb-search]');
      const categories = root.querySelector('[data-pb-categories]');
      const state = {};
      function readURL() {
        const url = new URL(location.href);
        for (const [key, param] of Object.entries(keys)) state[key] = url.searchParams.get(param) || '';
        if (!url.searchParams.has('pb_q')) state.query = root.dataset.pbInitialQuery || '';
        state.page = Math.max(1, Number.parseInt(state.page, 10) || 1);
        state.sort = state.sort || 'newest';
      }
      function route(filters) {
        const url = new URL(root.dataset.pbBrowse, location.origin);
        const previewTheme = new URL(location.href).searchParams.get('preview_theme_id');
        if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
        for (const [key, param] of Object.entries(keys)) if (filters[key]) url.searchParams.set(param, filters[key]);
        return url.pathname + url.search;
      }
      function syncURL() {
        if (home) return;
        const url = new URL(location.href);
        for (const [key, param] of Object.entries(keys)) {
          if (state[key] && !(key === 'page' && state.page === 1)) url.searchParams.set(param, state[key]);
          else url.searchParams.delete(param);
        }
        history.pushState({}, '', url.pathname + url.search + url.hash);
      }
      function conditionLabel(item) {
        if (!item.condition) return '';
        if (item.condition.status !== 'as_listed') return strings.check_condition;
        if (['good', 'fair', 'excellent', 'used'].includes(item.condition.filter_value)) return strings.preowned + ' · ' + item.condition.label;
        return item.condition.label || '';
      }
      function facts(item) {
        const size = item.size && item.size.status === 'listed' ? item.size.label : item.size && item.size.family_id && item.size.status === 'not_listed' ? strings.missing_size : item.size && item.size.status === 'confirm' ? strings.confirm_size : '';
        return [size, conditionLabel(item)].filter(Boolean).join(' · ');
      }
      function card(item, index) {
        const article = make('article', 'pb-card');
        article.dataset.pbProduct = item.product_id;
        const link = make('a', 'pb-card__link');
        const itemUrl = new URL(item.url, location.origin);
        if (item.available_variant_id) itemUrl.searchParams.set('variant', item.available_variant_id);
        link.href = itemUrl.pathname + itemUrl.search;
        const photo = make('div', 'pb-card__photo');
        if (item.image) {
          const image = make('img');
          image.src = item.image;
          image.alt = item.image_alt || item.title;
          image.width = 720;
          image.height = 720;
          image.loading = index < 4 ? 'eager' : 'lazy';
          image.decoding = 'async';
          photo.append(image);
        } else photo.append(make('span', 'pb-card__no-photo', strings.no_photo));
        const body = make('div', 'pb-card__body');
        body.append(make('p', 'pb-card__facts', facts(item)), make('h3', 'pb-card__title', item.title), make('p', 'pb-card__price', item.price_formatted));
        link.append(photo, body);
        article.append(link);
        return article;
      }
      function fillSelect(key, label) {
        const select = form.elements.namedItem(key);
        const filters = {...state};
        delete filters[key];
        const scoped = catalog.filter(products, filters);
        const values = [...new Set(scoped.map(item => value(item, key)).filter(Boolean))].sort((a,b) => a.localeCompare(b, undefined, {numeric:true}));
        if (state[key] && !values.includes(state[key])) values.push(state[key]);
        const first = select.options[0].textContent;
        select.replaceChildren(new Option(first, ''));
        for (const entry of values) select.add(new Option(label(entry), entry));
        select.value = state[key] || '';
      }
      function renderCategories() {
        const scoped = catalog.filter(products, {query:state.query});
        categories.replaceChildren();
        const all = make('a', '', strings.all + ' (' + scoped.length + ')');
        all.href = route({query:state.query});
        all.setAttribute('aria-current', String(!state.category_id && !state.hub_id));
        categories.append(all);
        const groups = [...manifest.hubs.map(hub => ({...hub, key:'hub_id'})), ...manifest.categories.map(category => ({...category, key:'category_id'}))];
        for (const group of groups) {
          const count = catalog.filter(scoped, {[group.key]:group.id}).length;
          if (!count && state[group.key] !== group.id) continue;
          const link = make('a', '', group.label + ' (' + count + ')');
          link.href = route({query:state.query, [group.key]:group.id});
          link.setAttribute('aria-current', String(state[group.key] === group.id));
          categories.append(link);
        }
      }
      function render() {
        let filtered = catalog.filter(products, home || related ? {sort:'newest'} : state);
        if (related) {
          const current = products.find(item => item.product_id === root.dataset.pbCurrentId && !item.needs_review);
          filtered = current ? filtered.filter(item => !item.needs_review && item.product_id !== current.product_id && item.equipment_id === current.equipment_id) : [];
          root.hidden = filtered.length === 0;
        }
        const limit = home || related ? Number(root.dataset.pbLimit) || 8 : 24;
        const pageCount = Math.max(1, Math.ceil(filtered.length / limit));
        state.page = Math.min(state.page || 1, pageCount);
        const offset = home || related ? 0 : (state.page - 1) * limit;
        grid.replaceChildren(...filtered.slice(offset, offset + limit).map(card));
        root.querySelector('[data-pb-empty]').hidden = filtered.length > 0;
        if (related) return;
        if (home) {
          for (const link of root.querySelectorAll('[data-pb-home-categories] a')) {
            const url = new URL(link.href);
            const filters = {category_id:url.searchParams.get('pb_category') || '', hub_id:url.searchParams.get('pb_hub') || ''};
            const count = catalog.filter(products, filters).length;
            link.hidden = count === 0;
            const existing = link.querySelector('small');
            if (existing) existing.remove();
            if (count) link.firstElementChild.append(make('small', '', count + ' ' + strings.count));
          }
          return;
        }
        search.elements.namedItem('pb_q').value = state.query;
        renderCategories();
        fillSelect('equipment_id', id => (manifest.equipment_groups.find(item => item.id === id) || {}).label || strings.unclassified);
        fillSelect('brand', entry => entry);
        fillSelect('size', entry => entry);
        fillSelect('condition', entry => {
          const item = products.find(product => value(product, 'condition') === entry);
          return item ? conditionLabel(item) : entry;
        });
        form.elements.namedItem('sort').value = state.sort;
        const group = manifest.categories.find(item => item.id === state.category_id) || manifest.hubs.find(item => item.id === state.hub_id);
        root.querySelector('[data-pb-heading]').textContent = group ? group.label : strings.all;
        root.querySelector('[data-pb-count]').textContent = filtered.length + ' ' + strings.count;
        const pages = root.querySelector('[data-pb-pages]');
        pages.replaceChildren();
        if (pageCount > 1) {
          const previous = make('button', '', strings.previous);
          previous.type = 'button';
          previous.disabled = state.page === 1;
          previous.addEventListener('click', () => changePage(state.page - 1));
          const nextButton = make('button', '', strings.next);
          nextButton.type = 'button';
          nextButton.disabled = state.page === pageCount;
          nextButton.addEventListener('click', () => changePage(state.page + 1));
          pages.append(previous, make('span', '', strings.page + ' ' + state.page + ' / ' + pageCount), nextButton);
        }
      }
      function changePage(page) {
        state.page = page;
        syncURL();
        render();
        root.querySelector('[data-pb-count]').scrollIntoView({block:'start', behavior:'auto'});
      }
      readURL();
      render();
      if (!home && !related) {
        form.hidden = false;
        categories.hidden = false;
        form.addEventListener('submit', event => event.preventDefault());
        form.addEventListener('change', event => {
          if (!Object.hasOwn(keys, event.target.name)) return;
          state[event.target.name] = event.target.value;
          state.page = 1;
          syncURL();
          render();
        });
        search.addEventListener('submit', event => {
          event.preventDefault();
          state.query = search.elements.namedItem('pb_q').value.trim();
          state.page = 1;
          syncURL();
          render();
        });
        root.querySelector('[data-pb-reset]').addEventListener('click', () => {
          for (const key of ['equipment_id','brand','condition','size']) state[key] = '';
          state.page = 1;
          syncURL();
          render();
        });
        window.addEventListener('popstate', () => { readURL(); render(); });
      }
    } catch (problem) {
      error();
      console.error('Playback catalog preview:', problem.message);
    }
  }
  function start(scope) { scope.querySelectorAll('[data-pb-shop]').forEach(init); }
  window.PlaybackShopUI = {start};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(document));
  else start(document);
  document.addEventListener('shopify:section:load', event => start(event.target));
}());
